import { Injectable } from '@angular/core';
import { FollowShipment } from '@app/models/follow-shipment';
import { FollowShipmentService } from '@app/services/api/follow-shipment.service';
import { FlashService } from '@app/services/flash.service';
import {
  AddAll,
  AddOne,
  Create,
  CreateFail,
  CreateSuccess,
  Load,
  LoadFail,
  LoadSuccess,
  Update,
  UpdateSuccess,
  UpdateFail,
  UpdateOne,
  FollowShipmentActionTypes,
  AddMany,
  Delete,
  DeleteSuccess,
  DeleteFail,
  RemoveOne,
  UpdateMany,
  UpdateManyFail,
  UpdateManySuccess
} from '@core/actions/follow-shipment.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, catchError, map, switchMap, exhaustMap } from 'rxjs/operators';

@Injectable()
export class FollowShipmentEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(FollowShipmentActionTypes.Load),
    map(action => [action.FollowId,action.infoview]),
    exhaustMap(([FollowId,infoview]) => {
      if(infoview){
        return this.followShipmentsApi.get(FollowId).pipe(
          map(
            (followShipments: FollowShipment[]) =>
              new LoadSuccess(followShipments)
          ),
          catchError(error => of(new LoadFail(error)))
        );
      }else{
        return this.followShipmentsApi.getCounter(FollowId).pipe(
          map(
            (followShipments: FollowShipment[]) =>
              new LoadSuccess(followShipments)
          ),
          catchError(error => of(new LoadFail(error)))
        );
      }
      
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(FollowShipmentActionTypes.LoadSuccess),
    map(action => new AddAll(action.shipments))
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(FollowShipmentActionTypes.Create),
    map(action => [action.FollowId, action.data]),
    switchMap(([FollowId, data]) =>
      this.followShipmentsApi.create(FollowId, data).pipe(
        map(
          (savedFollowShipments: FollowShipment[]) =>
            new CreateSuccess(savedFollowShipments)
        ),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  delete$: Observable<Action> = this.actions$.pipe(
    ofType<Delete>(FollowShipmentActionTypes.Delete),
    map(action => [action.shipment]),
    switchMap(([shipment]) =>
      this.followShipmentsApi.delete(shipment.FollowId, shipment.id).pipe(
        map(shipment => new DeleteSuccess(shipment)),
        catchError(error => of(new DeleteFail(error)))
      )
    )
  );

  @Effect()
  deleteSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteSuccess>(FollowShipmentActionTypes.DeleteSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Embarque elimindado' });
      return new RemoveOne(action.shipment);
    })
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(FollowShipmentActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Embarque creado' });
      return new AddMany(action.shipments);
    })
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(FollowShipmentActionTypes.Update),
    map(action => [action.id, action.shipment]),
    switchMap(([id, data]) => {
      return this.followShipmentsApi.update(id, data).pipe(
        map(
          (followShipments: FollowShipment[]) =>
            new UpdateSuccess(id, followShipments)
        ),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  @Effect()
  updateSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateSuccess>(FollowShipmentActionTypes.UpdateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Embarque actualizado' });
      return new UpdateOne(action.data);
    })
  );

  @Effect({ dispatch: false })
  updateFail$ = this.actions$.pipe(
    ofType<UpdateFail>(FollowShipmentActionTypes.UpdateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'Todos los  campos son necesarios',
        type: 'danger'
      })
    )
  );

  @Effect()
  updateMany$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateMany>(FollowShipmentActionTypes.UpdateMany),
    map(action => [action.id, action.shipments]),
    switchMap(([id, data]) => {
      return this.followShipmentsApi.updateMany(id, data).pipe(
        map(
          (followShipments: FollowShipment[]) =>
            new UpdateManySuccess(id, followShipments)
        ),
        catchError(error => of(new UpdateManyFail(error)))
      );
    })
  );

  @Effect({ dispatch: false })
  updateManySuccess$ = this.actions$.pipe(
    ofType<UpdateManySuccess>(FollowShipmentActionTypes.UpdateManySuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Embarques actualizado' });
      // return new UpdateOne(action.data);
    })
  );

  @Effect({ dispatch: false })
  updateManyFail$ = this.actions$.pipe(
    ofType<UpdateManyFail>(FollowShipmentActionTypes.UpdateManyFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'Error al actualizar',
        type: 'danger'
      })
    )
  );

  constructor(
    private actions$: Actions,
    private followShipmentsApi: FollowShipmentService,
    private fs: FlashService
  ) {}
}
